export const PALE_GREEN = '#81B4B5';
export const GREEN = '#187274';
export const ORANGE = '#FF8D2B';
export const WHITE = '#fff';
export const BLACK = '#222';